module.exports = __webpack_public_path__ + "static/media/Shared3.15509374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeOperation/Shared3.png
// module id = 212
// module chunks = 0